<template>
  <div class="c-list-skeleton">
    <c-list-item v-for="i in count" :key="i">
      <q-item-section v-if="showAvatar" avatar>
        <c-skeleton type="QAvatar" size="40px" />
      </q-item-section>

      <q-item-section>
        <c-skeleton type="text" width="50%" />
      </q-item-section>

      <q-item-section
        v-for="col in secondaryColumns"
        :key="col"
        class="tw-hidden md:tw-flex"
      >
        <c-skeleton type="text" width="40%" />
      </q-item-section>

      <q-item-section v-if="showBadge" side>
        <c-skeleton type="QBadge" width="80px" height="24px" />
      </q-item-section>

      <q-item-section v-if="showAction" side>
        <c-skeleton type="QBtn" width="120px" height="40px" />
      </q-item-section>
    </c-list-item>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import CListItem from "./CListItem.vue";

const props = withDefaults(
  defineProps<{
    count?: number;
    showAvatar?: boolean;
    showBadge?: boolean;
    showAction?: boolean;
    columns?: number;
  }>(),
  {
    count: 5,
    showAvatar: true,
    showBadge: true,
    showAction: false,
    columns: 1,
  },
);

const secondaryColumns = computed(() =>
  Array.from({ length: props.columns }, (_, i) => i),
);
</script>

<style lang="scss" scoped>
.c-list-skeleton {
  @apply tw-flex tw-flex-col;

  :deep(.q-skeleton) {
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.06) 0%,
      rgba(0, 0, 0, 0.06) 40%,
      rgba(0, 0, 0, 0.12) 50%,
      rgba(0, 0, 0, 0.06) 60%,
      rgba(0, 0, 0, 0.06) 100%
    );
    background-size: 200% 100%;
    animation: skeleton-sweep 1.5s ease-in-out infinite;
  }
}

@keyframes skeleton-sweep {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}
</style>
